import React from 'react';

export default function CustomLink ({ record }) {
    const id = record.id;
    const urlRes = '#/products/'+id;
    return(
        <a href={urlRes} style={{textDecoration:"none"}}>{record.id}</a>
    );
}